import Marquee from 'react-fast-marquee';
import { Asterisk } from 'lucide-react';

const WORDS = [
  'Sourced at origin',
  'Exported globally',
  'Premium grade',
  'Bulk commodity',
  'Lab-tested lots',
  'On-time shipment',
];

export default function SpiceMarquee() {
  return (
    <div className="border-y border-white/10 bg-coal/60 py-5" data-testid="editorial-marquee">
      <Marquee speed={26} gradient gradientColor="#0A0908" gradientWidth={140}>
        {WORDS.map((w) => (
          <span
            key={w}
            className="mx-7 flex items-center gap-7 whitespace-nowrap text-[13px] font-medium uppercase tracking-[0.3em] text-dune"
          >
            {w}
            <Asterisk className="h-4 w-4 text-turmeric" strokeWidth={1.5} aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
